import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import { useForm } from "react-hook-form";
import {
    AtualizarClassificacaoCobrancaController,
    GetClassificacaoCobrancaController,
    ListarClassificacaoCobrancaController,
    ListarClassificacaoCobrancaGrupoExcecaoController,
} from "../../../../../Controllers/Cobranca/ClassificacaoCobranca/ClassificacaoCobrancaController";

import {
    ClassificacaoCobrancaInterface,
    IClassificacaoCobrancaGrupoExcecao,
} from "../../../../../Interfaces/Cobranca/ClassificacaoCobranca/ClassificacaoCobrancaInterface";
import SpinnerComponent from "../../../../Loding/Spinner";
import Table from "../../../../Table";

export function ClassificacaoCobranca() {
    const { register, handleSubmit, formState } = useForm();
    const [LstClassificacaoCob, setLstClassificacaoCob] =
        useState<Array<ClassificacaoCobrancaInterface>>();
    const [Classificacao, setClassificacao] =
        useState<ClassificacaoCobrancaInterface>();
    const [ClassificacaoGrupoExcecao, setClassificacaoGrupoExcecao] =
        useState<Array<IClassificacaoCobrancaGrupoExcecao>>();

    useEffect(() => {
        updateList();
    }, []);

    function updateList() {
        ListarClassificacaoCobrancaController().then((res) => {
            setLstClassificacaoCob(res);
        });

        ListarClassificacaoCobrancaGrupoExcecaoController().then((res) => {
            setClassificacaoGrupoExcecao(res);
        });
    }

    function handleClassificacaocobFormSubmit(
        formData: ClassificacaoCobrancaInterface
    ) {
        if (Classificacao) {
            AtualizarClassificacaoCobrancaController({
                ID_CASO_COBRANCA_CLASSIFICACAO_COBRANCA:
                    Classificacao.ID_CASO_COBRANCA_CLASSIFICACAO_COBRANCA,
                FL_PERMITE_NEGOCIACAO: formData.FL_PERMITE_NEGOCIACAO,
                DS_LEGENDA: formData.DS_LEGENDA,
                ID_CASO_COBRANCA_CLASSIFICACAO_GRUPO_EXCECAO:
                    formData.ID_CASO_COBRANCA_CLASSIFICACAO_GRUPO_EXCECAO,
            }).then(() => {
                updateList();
            });
        }
    }

    function RowTable(cell: any, row: ClassificacaoCobrancaInterface) {
        return (
            <div className="rowCapysRC d-flex justify-content-between align-itens-center flex-row">
                <p className="p-2 font-weight-bold">
                    {row.DS_CASO_COBRANCA_CLASSIFICACAO_COBRANCA}
                </p>
            </div>
        );
    }

    function RowLegenda(cell: any, row: ClassificacaoCobrancaInterface) {
        return (
            <div className="">
                <p className="p-2 font-weight-bold">{row.DS_LEGENDA}</p>
            </div>
        );
    }

    function RowNegociacao(cell: any, row: ClassificacaoCobrancaInterface) {
        return (
            <div className="d-flex justify-content-center align-itens-center ">
                {row.FL_PERMITE_NEGOCIACAO ? (
                    <p className="p-2 font-weight-bold">Sim</p>
                ) : (
                    <p className="p-2 font-weight-bold">Não</p>
                )}
            </div>
        );
    }
    function RowEditar(cell: any, row: ClassificacaoCobrancaInterface) {
        return (
            <div className="d-flex justify-content-center align-itens-center ">
                <button
                    className="btn btn-outline-primary font-weight-bold"
                    type="button"
                    data-toggle="collapse"
                    data-target="#collapseForm"
                    aria-expanded="false"
                    aria-controls="collapseForm"
                    onClick={() => {
                        GetClassificacaoCobrancaController(
                            row.ID_CASO_COBRANCA_CLASSIFICACAO_COBRANCA
                        ).then((res) => {
                            setClassificacao(res);
                        });
                    }}
                >
                    <FontAwesomeIcon icon={faEdit} size="lg" />
                </button>
            </div>
        );
    }
    const ColunsClassificacaoCobranca: Array<ColumnDescription> = [
        {
            dataField: "DS_CASO_COBRANCA_CLASSIFICACAO_COBRANCA",
            text: "Classificação",
            formatter: RowTable,
            sort: true,
            isDummyField: true,
        },
        {
            dataField: "DS_LEGENDA",
            text: "Legenda",
            formatter: RowLegenda,
            sort: true,
            isDummyField: true,
        },
        {
            dataField: "FL_PERMITE_NEGOCIACAO",
            text: "Permite Negociação",
            formatter: RowNegociacao,
            sort: true,
            isDummyField: true,
        },
        {
            dataField: "FL_PERMITE_NEGOCIACAO",
            text: "",
            formatter: RowEditar,
            sort: true,
            isDummyField: true,
        },
    ];

    return LstClassificacaoCob !== undefined ? (
        <div className="">
            <div className="col-12 collapse mb-5" id="collapseForm">
                <h5 className="text-center">Edite Classificação Cobrança</h5>
                <form
                    onSubmit={handleSubmit(handleClassificacaocobFormSubmit)}
                    className="w-100 align-itens-center"
                >
                    <div className="row mb-3">
                        <div className="col-12 col-lg-6">
                            <label>Legenda</label>
                            <input
                                type="text"
                                name="DS_LEGENDA"
                                className={`form-control placeholder-dark-50 ${
                                    formState.errors.resultado && "is-invalid"
                                }`}
                                defaultValue={Classificacao?.DS_LEGENDA}
                                ref={register({
                                    required: "Insira o resultado do contato",
                                })}
                            />
                        </div>

                        <div className="col-12 col-lg-6">
                            <label>Exceção para o grupo</label>
                            <select
                                name="ID_CASO_COBRANCA_CLASSIFICACAO_GRUPO_EXCECAO"
                                className={`form-control placeholder-dark-50 ${
                                    formState.errors.classificacao &&
                                    "is-invalid"
                                }`}
                                ref={register()}
                                //disabled={LstObraEmpresasUAU?.length === null
                            >
                                <option></option>
                                {ClassificacaoGrupoExcecao?.map(
                                    (classificacao) => {
                                        return (
                                            <option
                                                key={classificacao.DS_GRUPO}
                                                value={classificacao.DS_GRUPO}
                                            >
                                                {classificacao.DS_GRUPO}
                                            </option>
                                        );
                                    }
                                )}
                            </select>
                        </div>

                        <div className="col-12 col-lg-12 d-flex justify-content-center align-itens-center flex-column mt-2">
                            <div className="d-flex justify-content-center align-itens-center">
                                <span>Permite Negociação</span>
                            </div>

                            <div>
                                <span
                                    className="switch switch-outline switch-sm switch-icon switch-warning d-flex justify-content-center"
                                    data-toggle="tooltip"
                                >
                                    <label>
                                        <input
                                            id="FL_PERMITE_NEGOCIACAO"
                                            name="FL_PERMITE_NEGOCIACAO"
                                            defaultChecked={
                                                Classificacao?.FL_PERMITE_NEGOCIACAO
                                            }
                                            ref={register()}
                                            type="checkbox"
                                        />
                                        <span></span>
                                    </label>
                                </span>
                            </div>
                        </div>
                    </div>

                    <button className="btn btn-outline-primary font-weight-bold d-flex col-12 justify-content-center">
                        <FontAwesomeIcon
                            icon={faEdit}
                            size="lg"
                            className="mr-1"
                        />{" "}
                        Editar
                    </button>
                </form>
            </div>
            <div className="table-responsive-sm ">
                <Table
                    keyField="ID_CASO_COBRANCA_CLASSIFICACAO_COBRANCA"
                    data={LstClassificacaoCob}
                    columns={ColunsClassificacaoCobranca}
                    noDataIndication={"Não existe Classificação Cobrança"}
                />
            </div>
        </div>
    ) : (
        <SpinnerComponent />
    );
}
